export default __webpack_public_path__ + "static/media/Bloodguard.c2409ed3.jpg";